import { Flex, Heading, Text } from '@qga/roo-ui/components';

interface UnavailableMessageProps {
  isAlternativeModal?: boolean;
}

const UnavailableMessage = ({
  isAlternativeModal,
}: UnavailableMessageProps) => {
  let heading = 'Not applicable';
  let text = 'This room is not part of this package option';
  if (isAlternativeModal) {
    heading = 'Unavailable';
    text = 'This room is not available on the selected travel dates';
  }

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="start"
      width={['100%', null, '200px']}
      textAlign="left"
    >
      <Heading.h6 fontWeight={700} mb={0} color="orange">
        {heading}
      </Heading.h6>
      <Text color="greys.steel" fontSize={['xs', null, 'sm']}>
        {text}
      </Text>
    </Flex>
  );
};

export default UnavailableMessage;
